import Settings from '../settings';
import { generatePreview } from './camio';

// FACEBOOK
export const postImageToFacebook = (facebookApi, data, pageId) => {
  const { replaceables, style, templateId } = data;
  const previewPayload = {
    assetId: templateId,
    replaceables,
    style
  };
  generatePreview(previewPayload)
    .then(response => {
      if (response.previewImg) {
        return facebookApi.uploadImage(
          `data:image/png;base64,${response.previewImg}`,
          data.description,
          pageId
        );
      }
      return Promise.resolve();
    })
    .catch(error => {
      console.log(error);
    });
};

// data: { accessToken, description, replaceables, title, userId, pageId }
export const postVideoToFacebook = (data, pageId) => {
  const url = `${Settings.serverPath}PublishingHandler.ashx`;
  fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...data,
      pageId,
      preset: 'facebook',
      url: `${data.apiUrl}/api/facebook/upload-video`
    }),
    dataType: 'json'
  })
    .then(response => response.text())
    .then(response => console.log(response))
    .catch(error => console.log(error));
};

// TWITTER
export const postImageToTwitter = (twitterApi, data) => {
  const { replaceables, style, templateId } = data;
  const previewPayload = {
    assetId: templateId,
    replaceables,
    style
  };
  generatePreview(previewPayload)
    .then(response => {
      if (response.previewImg) {
        return twitterApi.tweet(data.description, `data:image/png;base64,${response.previewImg}`);
      }
      return Promise.resolve();
    })
    .catch(error => {
      console.log(error);
    });
};

export const postVideoToTwitter = data => {
  const url = `${Settings.serverPath}PublishingHandler.ashx`;
  fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...data,
      preset: 'twitter',
      url: `${data.apiUrl}/api/twitter/tweet`
    }),
    dataType: 'json'
  })
    .then(response => response.text())
    .then(response => console.log(response))
    .catch(error => console.log(error));
};

// CAMIO
export const saveImageToCamio = (camioIpAddress, uploadData, assetData) => {
  const { replaceables, style, templateId, title } = assetData;
  const previewPayload = {
    assetId: templateId,
    replaceables,
    style,
    title
  };
  generatePreview(previewPayload)
    .then(response => {
      if (response.previewImg) {
        const url = `http://${camioIpAddress}/CAMIO4/SaveFromLuciHandler.ashx`;
        return fetch(url, {
          method: 'POST',
          mode: 'no-cors',
          body: JSON.stringify({
            metadata: {
              previewImg: response.previewImg,
              title,
              ...uploadData
            }
          }),
          dataType: 'json'
        });
      }
      return Promise.resolve();
    })
    .catch(error => console.log(error));
};

export const saveVideoToCamio = (camioIpAddress, uploadData, assetData) => {
  const url = `${Settings.serverPath}PublishingHandler.ashx`;
  fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      uploadData,
      ...assetData,
      preset: 'camio',
      url: `http://${camioIpAddress}/CAMIO4/SaveFromLuciHandler.ashx`
    }),
    dataType: 'json'
  })
    .then(response => response.text())
    .then(response => console.log(response))
    .catch(error => console.log(error));
};

const dataURItoBlob = dataUri => {
  const imageData = atob(dataUri);
  const arr = new Uint8Array(imageData.length);
  for (let i = 0; i < imageData.length; i++) {
    arr[i] = imageData.charCodeAt(i);
  }

  return new Blob([arr], { type: 'image/png' });
};

// Save to disk
export const saveImageToDisk = assetData => {
  const { replaceables, style, templateId, withPreviewOnlyImages } = assetData;
  const previewPayload = {
    assetId: templateId,
    replaceables,
    style,
    withPreviewOnlyImages
  };
  return generatePreview(previewPayload).then(response => {
    if (response.previewImg) {
      // create url from blob because large data uri won't get downloaded using <a/>
      const blob = dataURItoBlob(response.previewImg);
      const url = URL.createObjectURL(blob);
      // auto download preview
      const downloadLink = document.createElement('a');
      downloadLink.setAttribute('download', `${assetData.title}.png`);
      downloadLink.setAttribute('href', url);
      downloadLink.click();
    }
    return Promise.resolve(response);
  });
};



// WEBPACK FOOTER //
// ./app/api/publish.js